<template>
  <transition name="schedule">
    <section>
      <div class="row mt-5">
        <div class="col">
          <div class="table-responsive-lg">
            <h4>{{ $t('schedule.schedule') }} {{ this.$vnode.key }}</h4>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" colspan="2">{{ $t('schedule.time') }}</th>
                  <th scope="col" colspan="2">{{ $t('schedule.interval') }}</th>
                  <th scope="col" colspan="7">{{ $t('schedule.weekday') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ $t('schedule.start') }}</td>
                  <td>{{ $t('schedule.end') }}</td>
                  <td>{{ $t('schedule.on') }}</td>
                  <td>{{ $t('schedule.off') }}</td>
                  <td>{{ $t('schedule.mon') }}</td>
                  <td>{{ $t('schedule.tue') }}</td>
                  <td>{{ $t('schedule.wed') }}</td>
                  <td>{{ $t('schedule.thu') }}</td>
                  <td>{{ $t('schedule.fri') }}</td>
                  <td>{{ $t('schedule.sat') }}</td>
                  <td>{{ $t('schedule.sun') }}</td>
                </tr>
                <tr class="table-row-action">
                  <td>
                    <input
                      v-model="initialSchedule.time.on"
                      id="time_start"
                      class="form-control time"
                      type="time"
                      :disabled="isInputDisabled"
                      :class="{ 'form-error': errors.time }"
                    />
                  </td>
                  <td>
                    <input
                      v-model="initialSchedule.time.off"
                      id="time_end"
                      class="form-control time"
                      type="time"
                      :disabled="isInputDisabled"
                    />
                  </td>
                  <td>
                    <input
                      v-model.number="initialSchedule.interval.on"
                      class="form-control"
                      type="number"
                      :disabled="isInputDisabled"
                      :class="{ 'form-error': errors.interval }"
                    />
                  </td>
                  <td>
                    <input
                      v-model.number="initialSchedule.interval.off"
                      class="form-control"
                      type="number"
                      :disabled="isInputDisabled"
                      :class="{ 'form-error': errors.interval }"
                    />
                  </td>
                  <td>
                    <label class="custom-checkbox">
                      <input
                        type="checkbox"
                        v-model="initialSchedule.days.mon"
                        :disabled="isInputDisabled"
                        :true-value="1"
                        :false-value="0"
                        :class="{ 'form-error': errors.days }"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="custom-checkbox">
                      <input
                        type="checkbox"
                        v-model="initialSchedule.days.tue"
                        :disabled="isInputDisabled"
                        :true-value="1"
                        :false-value="0"
                        :class="{ 'form-error': errors.days }"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="custom-checkbox">
                      <input
                        type="checkbox"
                        v-model="initialSchedule.days.wed"
                        :disabled="isInputDisabled"
                        :true-value="1"
                        :false-value="0"
                        :class="{ 'form-error': errors.days }"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="custom-checkbox">
                      <input
                        type="checkbox"
                        v-model="initialSchedule.days.thu"
                        :disabled="isInputDisabled"
                        :true-value="1"
                        :false-value="0"
                        :class="{ 'form-error': errors.days }"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="custom-checkbox">
                      <input
                        type="checkbox"
                        v-model="initialSchedule.days.fri"
                        :disabled="isInputDisabled"
                        :true-value="1"
                        :false-value="0"
                        :class="{ 'form-error': errors.days }"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="custom-checkbox">
                      <input
                        type="checkbox"
                        v-model="initialSchedule.days.sat"
                        :disabled="isInputDisabled"
                        :true-value="1"
                        :false-value="0"
                        :class="{ 'form-error': errors.days }"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <label class="custom-checkbox">
                      <input
                        type="checkbox"
                        v-model="initialSchedule.days.sun"
                        :disabled="isInputDisabled"
                        :true-value="1"
                        :false-value="0"
                        :class="{ 'form-error': errors.days }"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>

            <Message v-if="!submit" :list="errors" type="danger" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col d-flex schedule-action">
          <a v-if="isInputDisabled" class="action-link" @click="editSchedule"
            ><MaterialSvg class="icon-cyaan" name="create" :width="24" />{{
              $t('button.edit')
            }}</a
          >
          <a
            v-if="!isInputDisabled"
            :class="{ 'form-cannot-submit': !submit }"
            class="action-link"
            @click="updateSchedule"
            ><MaterialSvg class="icon-cyaan" name="save" :width="24" />{{
              $t('button.save')
            }}</a
          >
          <a @click="deleteSchedule(id)" class="action-link"
            ><MaterialSvg class="icon-cyaan" name="delete" :width="24" />{{
              $t('button.delete')
            }}</a
          >
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
import { Action as ScheduleAction } from '@/store/schedule/types';
import { Action as DeviceAction } from '@/store/hubs/types';
import Message from './common/Message.vue';

export default {
  components: { Message },
  name: 'Schedule',
  data() {
    return {
      isInputDisabled: true,
      errors: {
        time: '',
        interval: '',
        days: '',
      },
      submit: true,
      initialSchedule: {
        id: Number,
        time: {
          on: '',
          off: '',
        },
        interval: {
          on: '',
          off: '',
        },
        days: {
          mon: Number,
          tue: Number,
          wed: Number,
          thu: Number,
          fri: Number,
          sat: Number,
          sun: Number,
        },
      },
    };
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    intervalOff: {
      type: Number,
      required: true,
    },
    intervalOn: {
      type: Number,
      required: true,
    },
    timeOff: {
      type: String,
      required: true,
    },
    timeOn: {
      type: String,
      required: true,
    },
    days: {
      type: Object,
      required: true,
    },
    maxSettings: {
      type: Number,
      required: true,
    },
    currentSettings: {
      type: Number,
      required: true,
    },
  },
  computed: {
    allowedDays() {
      return this.maxSettings - this.currentSettings;
    },
    activeDays() {
      return Object.values(this.days).filter((item) => item === 1).length;
    },
    selectedDays() {
      return Object.values(this.initialSchedule.days).filter(
        (item) => item === 1
      ).length;
    },
    addedDays() {
      return this.selectedDays - this.activeDays;
    },
  },
  created() {
    this.initializeSchedule();
  },
  watch: {
    'initialSchedule.time': {
      handler: function (newValue) {
        if (
          Date.parse('01/01/2018 ' + newValue.on + ':00') >=
          Date.parse('01/01/2018 ' + newValue.off + ':00')
        ) {
          this.errors.time = this.$t('error.starttime-endtime');
        } else {
          this.errors.time = '';
        }
      },
      deep: true,
    },
    'initialSchedule.interval': {
      handler: function (newValue) {
        if (newValue.on >= newValue.off) {
          this.errors.interval = this.$t('error.on-off');
        } else if (newValue.on <= 2) {
          this.errors.interval = this.$t('error.two-seconds');
        } else if (newValue.off <= 20) {
          this.errors.interval = this.$t('error.twenthy-seconds');
        } else {
          this.errors.interval = '';
        }
      },
      deep: true,
    },
    'initialSchedule.days': {
      handler: function (newValue) {
        if (this.addedDays > this.allowedDays) {
          this.errors.days = this.$t('error.days');
        } else {
          this.errors.days = '';
        }
      },
      deep: true,
    },
    errors: {
      handler: function (newValue) {
        if (newValue.time || newValue.interval || newValue.days) {
          this.submit = false;
        } else {
          this.submit = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    initializeSchedule() {
      this.initialSchedule.id = this.id;
      this.initialSchedule.time.on = this.timeOn;
      this.initialSchedule.time.off = this.timeOff;
      this.initialSchedule.interval.on = this.intervalOn;
      this.initialSchedule.interval.off = this.intervalOff;
      this.initialSchedule.days.mon = this.days.mon;
      this.initialSchedule.days.tue = this.days.tue;
      this.initialSchedule.days.wed = this.days.wed;
      this.initialSchedule.days.thu = this.days.thu;
      this.initialSchedule.days.fri = this.days.fri;
      this.initialSchedule.days.sat = this.days.sat;
      this.initialSchedule.days.sun = this.days.sun;
      // Code below is preferred, but some weird muatable shit is going on.
      // this.initialSchedule = {
      //   id: this.id,
      //   timeOn: this.timeOn,
      //   timeOff: this.timeOff,
      //   intervalOn: this.intervalOn,
      //   intervalOff: this.intervalOff,
      //   days: this.days,
      // };
    },
    deleteSchedule(scheduleId) {
      this.$parent.$emit('delete-schedule', scheduleId);
    },
    editSchedule() {
      this.isInputDisabled = !this.isInputDisabled;
    },
    updateSchedule() {
      if (this.submit) {
        // Map fields to match b2b-portal.
        let changedFields = {
          ...this.initialSchedule.days,
          start: this.initialSchedule.time.on,
          end: this.initialSchedule.time.off,
          interval_on: this.initialSchedule.interval.on,
          interval_off: this.initialSchedule.interval.off,
        };
        this.$store
          .dispatch(`${ScheduleAction.UPDATE_SCHEDULE}`, {
            hash: this.$route.params.hash,
            fields: changedFields,
            scheduleId: this.id,
          })
          .then((resp) => {
            // Get device to reload schedule.
            this.$store.dispatch(
              `${DeviceAction.GET_DEVICE}`,
              this.$route.params.hash
            );
          })
          .catch((error) => {
            console.log(error);
          });
        this.isInputDisabled = !this.isInputDisabled;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form-control {
  font-size: 0.8em;
  max-width: 90px;

  &:disabled {
    background-color: transparent;
    color: $white;
    border: 0;
    padding: 0;
    appearance: none;
  }
}
.time {
  padding-right: 3px;
  &::-webkit-calendar-picker-indicator {
    filter: invert(1);
  }
}
// Custom checkbox
.custom-checkbox {
  display: block;
  position: relative;
  user-select: none;
  height: 24px;
  width: 24px;

  input {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }

  &:hover input ~ .checkmark {
    background-color: #081b28;
  }

  &:hover input:not(:checked):disabled ~ .checkmark {
    background-color: transparent;
  }

  input:checked ~ .checkmark {
    background-color: #081b28;
  }

  input.form-error ~ .checkmark {
    border: 1px solid $error !important;
  }

  input:checked ~ .checkmark:after {
    display: block;
  }

  input:disabled ~ .checkmark {
    border: 0;
  }
  .checkmark:after {
    width: 24px;
    height: 24px;
    background-image: url(/images/icons/done-24px.svg);
    background-size: 24px;
    background-repeat: no-repeat;
  }
  .checkmark {
    position: absolute;
    top: 4px;
    left: 0;
    height: 24px;
    width: 24px;
    background-color: transparent;
    border: 1px solid $dark-bluegrey;
    border-radius: 2px;

    &:after {
      content: '';
      position: absolute;
      display: none;
    }
  }
}

.schedule-enter-from,
.schedule-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.schedule-enter-active {
  transition: all 0.8s ease-out;
}

.schedule-leave-active {
  transition: all 0.8s ease-in;
}

.schedule-enter-to,
.schedule-leave-from {
  opacity: 1;
  transform: translateY(30px);
}
</style>